import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=1bca38b0"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports